module.exports = __webpack_public_path__ + "static/media/shrugging.649c238e.mp4";